import { render, staticRenderFns } from "./ActivateRobot.vue?vue&type=template&id=21316f6c&scoped=true&"
import script from "./ActivateRobot.vue?vue&type=script&lang=js&"
export * from "./ActivateRobot.vue?vue&type=script&lang=js&"
import style0 from "./ActivateRobot.vue?vue&type=style&index=0&id=21316f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21316f6c",
  null
  
)

export default component.exports